import script from "./AppSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./AppSwitcher.vue?vue&type=style&index=0&id=6c62d082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c62d082"]])

export default __exports__